import * as stylex from '@stylexjs/stylex';
import _ from 'lodash';
import { isNewHomeScreen2025Enabled } from '@/services/systemConfiguration.utilities';
import { faCaretLeft, faCaretRight } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon, Paginator as QomponentsPaginator } from '@seeqdev/qomponents';
import { colors } from '@seeqdev/qomponents/colors.stylex';

interface PaginatorProps {
  gotoPage: (page: number) => void;
  pageCount: number;
  pageNumber: number;
  pageSize?: number;
  setPageSize?: (size: number) => void;
  insideModal?: boolean;
  total?: number;
  pageSizeOptionsCustom?: number[];
  small?: boolean;
  allowCustomPageSize?: boolean;
}

export const Paginator = ({
  gotoPage,
  pageCount,
  pageNumber,
  pageSize,
  setPageSize = _.noop,
  insideModal = false,
  total,
  pageSizeOptionsCustom,
  small = false,
  allowCustomPageSize = false,
}: PaginatorProps) => {
  return (
    <div {...stylex.props(!isNewHomeScreen2025Enabled() && paginatorStyles.separated)} data-testid="paginatorContainer">
      <div
        {...stylex.props(paginatorStyles.controls, small ? paginatorStyles.small : paginatorStyles.normal)}
        data-testid="paginatorControls">
        <QomponentsPaginator
          pageCount={pageCount}
          pageNumber={pageNumber}
          pageSize={pageSize}
          variant={insideModal ? 'compact' : 'normal'}
          total={total}
          pageSizeOptions={pageSizeOptionsCustom}
          size={small ? 'small' : 'normal'}
          creatablePageSizes={allowCustomPageSize}
          previousLabel={insideModal ? <Icon icon={faCaretLeft} /> : undefined}
          nextLabel={insideModal ? <Icon icon={faCaretRight} /> : undefined}
          breakXstyle={paginatorStyles.pageBreak}
          onPageChange={gotoPage}
          onPageSizeChange={setPageSize}
        />
      </div>
    </div>
  );
};

export const paginatorStyles = stylex.create({
  separated: { borderTopWidth: 1, borderTopStyle: 'solid', borderTopColor: colors.toolPanelBorder },
  controls: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap' },
  pageBreak: { color: colors.bodyText },
  small: { marginRight: '.3125rem' },
  normal: { marginBlock: '.25rem', marginInline: '.75rem' },
});
